'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

const images = [
{ id: 'img-001', src: "https://img.rocket.new/generatedImages/rocket_gen_img_16078fa54-1773044077044.png", alt: 'Luxury beachfront villa exterior with pool and ocean views at golden hour in Saadiyat Island Abu Dhabi' },
{ id: 'img-002', src: "https://img.rocket.new/generatedImages/rocket_gen_img_17df2f57b-1772210224827.png", alt: 'Spacious open-plan living room with floor-to-ceiling windows and sea view in Dubai villa' },
{ id: 'img-003', src: "https://images.unsplash.com/photo-1713041788210-cce153e79ae2", alt: 'Modern kitchen with marble countertops and premium appliances in UAE luxury property' },
{ id: 'img-004', src: "https://img.rocket.new/generatedImages/rocket_gen_img_126d22dc9-1773058604528.png", alt: 'Master bedroom suite with private terrace overlooking the Arabian Gulf in Dubai' },
{ id: 'img-005', src: "https://img.rocket.new/generatedImages/rocket_gen_img_1217475fc-1772167243094.png", alt: 'Infinity pool with palm trees and Arabian Gulf panorama at luxury UAE villa' }];


export default function PropertyGallery() {
  const [activeIdx, setActiveIdx] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);

  return (
    <>
      <div className="relative bg-primary-dark">
        {/* Main Image */}
        <div className="relative h-[520px] xl:h-[600px] overflow-hidden cursor-pointer" onClick={() => setLightboxOpen(true)}>
          <AppImage
            src={images?.[activeIdx]?.src}
            alt={images?.[activeIdx]?.alt}
            fill
            priority
            className="object-cover"
            sizes="100vw" />
          
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/40" />

          {/* Image Counter */}
          <div className="absolute top-6 right-6 flex items-center gap-2 bg-black/50 backdrop-blur-sm text-white text-sm font-semibold px-3 py-1.5 rounded-full">
            <Icon name="PhotoIcon" size={16} />
            {activeIdx + 1} / {images?.length}
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={(e) => {e?.stopPropagation();setActiveIdx(Math.max(0, activeIdx - 1));}}
            disabled={activeIdx === 0}
            className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/40 backdrop-blur-sm text-white flex items-center justify-center hover:bg-black/60 transition-all disabled:opacity-30">
            
            <Icon name="ChevronLeftIcon" size={20} />
          </button>
          <button
            onClick={(e) => {e?.stopPropagation();setActiveIdx(Math.min(images?.length - 1, activeIdx + 1));}}
            disabled={activeIdx === images?.length - 1}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/40 backdrop-blur-sm text-white flex items-center justify-center hover:bg-black/60 transition-all disabled:opacity-30">
            
            <Icon name="ChevronRightIcon" size={20} />
          </button>

          {/* Action Buttons */}
          <div className="absolute top-6 left-6 flex gap-2">
            <button className="flex items-center gap-1.5 bg-black/40 backdrop-blur-sm text-white text-xs font-semibold px-3 py-2 rounded-full hover:bg-black/60 transition-all">
              <Icon name="VideoCameraIcon" size={14} />
              Video Tour
            </button>
            <button className="flex items-center gap-1.5 bg-black/40 backdrop-blur-sm text-white text-xs font-semibold px-3 py-2 rounded-full hover:bg-black/60 transition-all">
              <Icon name="CubeIcon" size={14} />
              Virtual Tour
            </button>
            <button className="flex items-center gap-1.5 bg-black/40 backdrop-blur-sm text-white text-xs font-semibold px-3 py-2 rounded-full hover:bg-black/60 transition-all">
              <Icon name="DocumentIcon" size={14} />
              Floor Plan
            </button>
          </div>

          {/* Bottom Actions */}
          <div className="absolute bottom-6 right-6 flex gap-2">
            <button className="flex items-center gap-1.5 bg-black/40 backdrop-blur-sm text-white text-xs font-semibold px-3 py-2 rounded-full hover:bg-black/60 transition-all">
              <Icon name="HeartIcon" size={14} />
              Save
            </button>
            <button className="flex items-center gap-1.5 bg-black/40 backdrop-blur-sm text-white text-xs font-semibold px-3 py-2 rounded-full hover:bg-black/60 transition-all">
              <Icon name="ShareIcon" size={14} />
              Share
            </button>
            <button className="flex items-center gap-1.5 bg-black/40 backdrop-blur-sm text-white text-xs font-semibold px-3 py-2 rounded-full hover:bg-black/60 transition-all">
              <Icon name="ScaleIcon" size={14} />
              Compare
            </button>
          </div>
        </div>

        {/* Thumbnails */}
        <div className="flex gap-2 px-6 py-3 bg-primary-dark overflow-x-auto scrollbar-hide">
          {images?.map((img, i) =>
          <button
            key={img?.id}
            onClick={() => setActiveIdx(i)}
            className={`relative flex-shrink-0 w-20 h-14 rounded-lg overflow-hidden transition-all ${
            i === activeIdx ? 'ring-2 ring-accent ring-offset-2 ring-offset-primary-dark' : 'opacity-60 hover:opacity-100'}`
            }>
            
              <AppImage src={img?.src} alt={img?.alt} fill className="object-cover" sizes="80px" />
            </button>
          )}
        </div>
      </div>
      {/* Lightbox */}
      {lightboxOpen &&
      <div className="fixed inset-0 z-[200] bg-black/95 flex items-center justify-center" onClick={() => setLightboxOpen(false)}>
          <button className="absolute top-6 right-6 text-white hover:text-accent transition-colors" onClick={() => setLightboxOpen(false)}>
            <Icon name="XMarkIcon" size={28} />
          </button>
          <div className="relative w-full max-w-5xl h-[70vh] mx-8" onClick={(e) => e?.stopPropagation()}>
            <AppImage src={images?.[activeIdx]?.src} alt={images?.[activeIdx]?.alt} fill className="object-contain" sizes="90vw" />
          </div>
        </div>
      }
    </>);

}